import {del, get, post, put} from "@/services/api"


const state = {
    tests: [],
    testsBySubjectId: [],
    didLoadedTests: false,
    didLoadTest: false,
    defaultTest: {
        id: null,
        activated: false,
        categoryId: 1,
        name: '',
        subjectId: null,
        showAnswers: false,
        hidden: false,
        questions: [],
        imageId: null,
    },
    test: {
        id: null,
        activated: false,
        categoryId: 1,
        name: '',
        subjectId: null,
        showAnswers: false,
        hidden: false,
        questions: [],
        orderedQuestions: [],
        imageId: null,
    },
    images: []
};

const getters = {
    getTests: state => state.tests,
    getTestsBySubjectId: state => state.testsBySubjectId,
    getTest: state => state.test,
    getEmptyTest: state => state.defaultTest,
    getImages: state => state.images,
    didLoadedTests: state => state.didLoadedTests,
    didLoadTest: state => state.didLoadTest,
};

const actions = {

    async fetchAllTests({commit}) {
        commit('setDidLoadedTests', false);
        await get('gamification/tests/')
            .then((response) => {
                commit('setTests', response.data.items);
                commit('setDidLoadedTests', true);
            });
    },

    async fetchTestById({commit}, id) {
        commit('errors/clear', null, { root: true });
        commit('setDidLoadTest', false);
        const response = await get('gamification/tests/' + id);
        commit('updateTest', response.data.content);
        commit('setDidLoadTest', true);
    },

    async fetchTestsBySubjectId({commit}, subjectId){
        const response = await get('gamification/tests/by_subject/' + subjectId);
        commit('setTestsBySubjectId', response.data.items)
        return response.data.items
    },

    async createTest({commit}, {item}) {
        const response = await post('gamification/tests/', item);
        const newTest = response.data.content;
        commit('addTest', newTest);
        return newTest.id;
    },

    async deleteTestById({commit}, id) {
        await del(`gamification/tests/${id}`)
        commit('filterTests', id);
    },

    async updateTest({commit}, {item}) {
        await put(`gamification/tests/${item.id}`, item)
            .then((response) => {
                commit('updateTest', response);
            })
            .catch(e => alert(e.message));
    },

    async fetchAllImages({commit}){
        const response = await get('gamification/tests/images')
        commit('setImages', response.data.items)
    },

    prepareNewTest({ commit }) {
        commit('prepareNewTest');
    }
};

const mutations = {
    setDidLoadedTests: (state, value) => (state.didLoadedTests = value),
    setDidLoadTest: (state, value) => (state.didLoadTest = value),
    addTest: (state, item) => (state.tests.push(item)),
    setTests: (state, tests) => (state.tests = tests),
    setTestsBySubjectId: (state, tests) => (state.testsBySubjectId = tests),
    filterTests: (state, id) => (state.tests = state.tests.filter(tests => tests.id !== id)),
    updateTest: (state, item) => (Object.assign(state.test, item)),
    prepareNewTest: ( state ) => (Object.assign(state.test, state.defaultTest)),
    setImages: (state, items) => (state.images = items)
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}